export default __webpack_public_path__ + "static/media/stkAAVE.e81a2d4f.svg";